<label [class.sr-only]="!showLabel" [class.as-placeholder]="showLabel && !label?.length && !openSelect && !disabled"
    [for]="name">{{placeholder | translate}}</label>


<input #selectInput type="text" class="form-control" [id]="name" [name]="name" [tabindex]="index" [ngModel]="label"
    [placeholder]="!showLabel ? (placeholder | translate) : ''" [title]="placeholder | translate"
    (focus)="onFocus(value)" readonly (blur)="onBlur($event)" [ngClass]="{
        'is-invalid': !!selectedOption[options?.colorKeys?.error],
        'is-valid warning': !!selectedOption[options?.colorKeys?.warning]
    }" [ngStyle]="{'border-color': selectedOption | optionsListStyle : options?.styleFn }"
    [class]="selectedOption | optionsListStyle : options?.classFn" [disabled]="disabled" autocomplete="off">

<div *ngIf="openSelect && optionsList.length" class="select-container" aria-live="polite">

    <div class="select px-2">
        <div class="options-container">
            <ng-container *ngFor="let option of optionsList; let i = index">
                <div [tabindex]="index" [id]="'selectOpt-' + i" class="options" (blur)="onBlur($event)"
                    [ngStyle]="{'color': option | optionsListStyle : options?.styleFn }"
                    [class]="option | optionsListStyle : options?.classFn" [ngClass]="{
                            'error': !!option[options?.colorKeys?.error],
                            'warning': !!option[options?.colorKeys?.warning]
                        }" (mousedown)="selectOption(option)" (keydown.enter)="selectOption(option)">
                    <div class="form-check">
                        <input [id]="'ms-checkbox-' + i" type="checkbox" [(ngModel)]="option.isSelected"
                            (click)="preventDefault($event)" (blur)="onBlur($event)">
                        <label class="checkbox-label" [for]="'ms-checkbox-' + i">
                            {{option | optionsListLabel : options?.labelKey : options?.outputKey || labelKey}}
                        </label>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<div class="icons-container">
    <div class="select-icons">
        <span *ngIf="label" class="remove-icon" [tabindex]="index" (keydown.enter)="resetModel()"
            (click)="resetModel()">
            &times;
        </span>
        <span class="toggle-arrow" [class.open]="openSelect && optionsList.length"></span>
    </div>
</div>